import Vue from 'vue';

Vue.component('language-selector', {
    props: {
        languageUrl: {
            type: String,
        },
    },

    data() {
        return {
            showLanguageOptions: false,
        }
    },

    mounted() {

    },

    methods: {
        /**
         * Click event that handles a link and ignores
         * the router.
         *
         * @returns {Void}
         */
        ignoreRouter(event) {
            const href = event.currentTarget.href;
            window.location = href;
        },
        toggleLanguageSwitch() {
            this.showLanguageOptions = !this.showLanguageOptions;
        },

    }
});